import Delegate from "ftdomdelegate";
import { add, remove, qs, qsa, listen } from "@fluorescent/dom";
import { emit } from "@/glow/events";
import { cart } from "@/glow";
import {
  initQuickAddTemplateCounters,
  initQuickAddQuantitySelectors,
} from "@/lib/quick-add";
import { animateProductItem } from "@/lib/animation";

const selectors = {
  item: ".product-item",
  itemInner: ".product-item__inner",
  itemMedia: ".product-item__image-link",
  itemBadges: ".product-badges",
  itemTitle: ".product-item__product-title",
  quantityWrapper: ".quantity-input",
  quickAddWrapper: ".product-item__quick-add-wrapper",
  quickAddButton: ".product-item__quick-add",
  quickViewButton: ".show-product-quick-view",
  hoverableSwatch:
    ".product-swatches-options__item[data-has-hover-interaction='true']",
  hoverableSwatchContainer: ".product-swatches-options__list",
  largeSwatchPreview: ".product-item__image__swatch_preview",
};

const classes = {
  active: "active",
  updatingQuantity: "pending-quantity-update",
};

export default function ProductItem(container) {
  const items = qsa(selectors.item, container);

  if (!items.length) return;

  const productItemAnimations = animateProductItem(items);

  const quickAddWrappers = qsa(selectors.quickAddWrapper, container);
  const quickAddButtons = qsa(selectors.quickAddButton, container);
  const quickViewButtons = qsa(selectors.quickViewButton, container);

  const quickAddInstances = [];
  quickAddWrappers.forEach(wrapper => {
    quickAddInstances.push(initQuickAddTemplateCounters(wrapper));
    quickAddInstances.push(initQuickAddQuantitySelectors(wrapper));
  });

  // TODO: Enable when we set this functionality up in 1.1+
  /* const hoverableSwatches = qsa(selectors.hoverableSwatch, container);
  const hoverableSwatchContainers = qsa(
    selectors.hoverableSwatchContainer,
    container
  ); */

  // If there's a click outside a quick add, remove the active
  // class (ie. hide quantity selector, and show button)
  const delegate = new Delegate(container);
  delegate.on("click", null, e => {
    const quickAddWrapper = e.target.closest(selectors.quickAddWrapper);

    if (!quickAddWrapper) {
      deactivateQuickAddWrappers();
    }
  });

  const events = [
    listen(quickAddButtons, "click", e => {
      const parentWrapper = e.currentTarget.closest(selectors.quickAddWrapper);
      const { hasVariants, productId } = parentWrapper.dataset;

      deactivateQuickAddWrappers();

      if (hasVariants === "true") {
        e.preventDefault();
        e.stopPropagation();

        // Removing until the quick add functionaliy can be more fleshed out.
        /*const template = qs(
          `#quick-add-modal-content-for-id-${productId}`,
          container
        );*/

        /*emit("modal:open", null, {
          modalContent: template.content,
          quickAdd: true,
        });*/

        const productEl = e.currentTarget.closest(selectors.item);
        const url = productEl.dataset.url;
        const title = productEl.dataset.title;

        emit("quick-add:open", null, {
          type: "quick-add",
          productUrl: url,
          productTitle: title,
        });
      } else {
        const { quantityInCart, variantId } = e.currentTarget.dataset;

        if (parseInt(quantityInCart) < 1) {
          const currentQuantityInput = qs(
            selectors.quantityWrapper,
            parentWrapper
          );
          const currentInput = qs("input", parentWrapper);

          add(currentQuantityInput, classes.updatingQuantity);
          currentInput.value = 1;
          cart.addItemById(variantId, 1);
        }

        add(parentWrapper, classes.active);
      }
    }),

    listen(quickViewButtons, "click", e => {
      e.preventDefault();
      e.stopPropagation();
      const clickedEl = e.currentTarget;
      const productEl = clickedEl.closest(selectors.item);
      const url = productEl.dataset.url;
      const media = qs(selectors.itemMedia, productEl);
      const badges = qs(selectors.itemBadges, productEl);
      const title = productEl.dataset.title;

      emit("quick-view:open", null, {
        type: "quick-view",
        productUrl: url,
        productMedia: media,
        productBadges: badges,
        productTitle: title,
      });

      deactivateQuickAddWrappers();
    }),

    // TODO: Enable when we set this functionality up in 1.1+
    /* listen(hoverableSwatches, "mouseenter", e => {
      const swatchEl = e.currentTarget;
      const productEl = swatchEl.closest(selectors.item);
      const largeSwatchPreviewEl = qs(selectors.largeSwatchPreview, productEl);
      const backgroundType = swatchEl.dataset.swatchColorType;

      largeSwatchPreviewEl.style.backgroundColor = "";
      largeSwatchPreviewEl.style.backgroundImage = "";

      if (backgroundType === "image") {
        // Using small and large bg image to avoid loading flash (small is loaded first, and large is overlaid)
        largeSwatchPreviewEl.style.backgroundImage = `url('${swatchEl.dataset.colorImageLarge}'), ${swatchEl.style.backgroundImage}`;
      } else if (backgroundType === "color") {
        largeSwatchPreviewEl.style.backgroundColor = swatchEl.dataset.color;
      }

      largeSwatchPreviewEl.classList.add("visible");
    }),

    listen(hoverableSwatchContainers, "mouseleave", e => {
      const productEl = e.currentTarget.closest(selectors.item);
      const largeSwatchPreviewEl = qs(selectors.largeSwatchPreview, productEl);
      largeSwatchPreviewEl.classList.remove("visible");
    }), */
  ];

  const deactivateQuickAddWrappers = () => {
    quickAddWrappers.forEach(wrapper => {
      remove(wrapper, classes.active);
    });
  };

  const unload = () => {
    productItemAnimations.destroy();
    quickAddInstances.forEach(instance => instance.unload());
    events.forEach(unsubscribe => unsubscribe());
  };

  return { unload };
}
